module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_1-b3c33f709b2c920c81120de1a900aed1.jpg";